import { ErrorHandler } from '@angular/core';
// @ts-ignore
import AirbrakeClient from 'airbrake-js';
// import {environment} from '../environments/environment';

export class AirbrakeErrorHandler implements ErrorHandler {
  airbrake: AirbrakeClient;

  constructor() {
    /*if (environment.config.AIRBRAKE_ENVIRONMENT_TYPE !== 'development') {
      this.airbrake = new AirbrakeClient({
        projectId: environment.config.AIRBRAKE_PROJECT_ID,
        projectKey: environment.config.AIRBRAKE_PROJECT_KEY,
        environment: environment.config.AIRBRAKE_ENVIRONMENT_TYPE
      });
    }*/
  }

  handleError(error: any): void {
    /*if (environment.config.AIRBRAKE_ENVIRONMENT_TYPE !== 'development') {
      this.airbrake.notify(error);
    }*/
  }
}
